import React from "react";
import { TooltipContextData } from "./types";

export const TooltipContext = React.createContext<TooltipContextData>({
  setTooltip: () => undefined,
});
